<!--公告及新闻稿-->
<template>
    <div>
      <transition name="moveing">
        <navgate-other ref="topTitle" v-show="isShowTopTitle"></navgate-other>
      </transition>
      
      <main class="index_main_content" ref="parentDiv">
        <div class="index_main_body other" ref="topDiv">
            <div class="zcgy_img"><img src="../../../assets/img/society/shehui-banner.jpg"><div class="mask_bg"></div></div>
            <div class="zcgy_word">
            <div class="zcgy_ch">技术立业 持续发展</div>
            <div class="zcgy_en">Sustainable Development Of Technology</div>
            </div>
        </div>
        <!--二级导航定格-->
        <div class="second_nav_top" v-show="lockSecondTop" >
          <div class="second_nav_list">
            <div div :class="{active_d:(selectedSecond == '环境、社会及管治报告')}" @click="gotoPoint('report','环境、社会及管治报告')" >环境、社会及管治报告</div>
            <!-- <div :class="{active_d:(selectedSecond == '科技点亮公益')}" @click="gotoPoint('lightFund','科技点亮公益')">科技点亮公益</div> -->
            <div :class="{active_d:(selectedSecond == 'ESG评级与奖项')}" @click="gotoPoint('buildFuture','ESG评级与奖项')">ESG评级与奖项</div>
            <div :class="{active_d:(selectedSecond == '公益基金会')}" @click="clickSecondHandler('公益基金会')">公益基金会</div>
          </div>
        </div>
        <!--二级导航-->
        <div class="second_nav" ref="secondNav">
          <div class="second_nav_list">
            <div :class="{active_d:(selectedSecond == '环境、社会及管治报告')}" @click="gotoPoint('report','环境、社会及管治报告')" >环境、社会及管治报告</div>
            <!--<div :class="{active_d:(selectedSecond == '科技点亮公益')}" @click="gotoPoint('lightFund','科技点亮公益')">科技点亮公益</div>-->
            <div :class="{active_d:(selectedSecond == 'ESG评级与奖项')}" @click="gotoPoint('buildFuture','ESG评级与奖项')">ESG评级与奖项</div>
            <div :class="{active_d:(selectedSecond == '公益基金会')}" @click="clickSecondHandler('公益基金会')">公益基金会</div>
          </div>
        </div>
        <!--内容-->
        <div class="aboutus_body_box">
        <div class="about_wenhua_layout" ref="report">
          <div class="web_title">环境、社会及管治报告</div>
          <div class="society_one">
            <div class="report_layout" v-if="(socityData && socityData.list.length > 0)" @click="openReport(socityData.list[0]['msgUrl'])">
              <div class="ESG_report">
                <div class="ESG_img"><img class="report_img" :src="socityData.list[0]['imageUrl']"></div>
                <!--<div class="ESG_img"><img class="report_img" src="../../../assets/img/111.jpg"></div>-->
                <div class="ESG_name">
                  <div class="ESG_title">{{socityData.list[0]['year']}} {{socityData.list[0]['title']}}</div>
                  <div class="ESG_icon"><i class="iconfont icon-website-PDF"></i>PDF</div>
                </div>
              </div>


              <div class="report_title" style="display: none;">
                <div class="report_year">{{socityData.list[0]['year']}}</div>
                <div class="report_name">{{socityData.list[0]['title']}}</div>
                <i class="iconfont icon-website-PDF"></i>
              </div>
            </div>
            <div class="talk_box">
              <div class="talk_title">主席致辞</div>
              <div class="talk_word">
                2024年，在新一轮人工智能技术革命重塑技术生态与行业结构的背景下，金山软件始终坚守「技术立业」的初心，以创新为驱动，
                不断加大研发投入，致力于提升技术实力、产品和服务竞争力。三十六年来，我们在办公软件、游戏产品与服务等领域不断创新突破的同时，
                积极履行社会责任，持续将ESG理念深度融入企业战略， 使其成为公司持续前行、创造长期价值的新引擎。
                秉持著对社会的深厚责任感与对技术的执著追求，金山软件从完善治理架构到塑造卓越服务，从绿色办公到乡村教育帮扶，全方位发力，
                践行ESG理念，共筑可持续未来。
                <br><br>
                志存高远，方知天地广阔；脚踏实地，始得千里跬步。展望未来，我们将面对越来越多的新常态和新机遇，将继续秉承「技术立业」的理念，
                怀揣梦想、坚守正直、勇担责任。在数字化的浪潮中，我们将以更加坚定的步伐向新而行，向高攀登，以全球视野为导向，
                与全球顶尖科技企业同场竞技、交流合作，用卓越的技术实力与创新成果，为行业发展注入源源不断的金山动力，以匠心服务用户，用创新回馈社会。
              </div>
              <div class="talk_sign">
                <div>雷军</div>
                <div>董事会主席</div>
              </div>
            </div>
          </div>
        </div>
        <!--历年报告-->
        <div class="about_yewu_layout">
          <div class="baogao_width">
            <div class="web_title">历年报告</div>
            <div class="baogaolist_box">
                <div v-for="report,index in showList" class="baogao_list" :key="index" @click="openReport(report['msgUrl'])">
                  <div class="fengmian"><img :src="report.imageUrl"></div>
                  <div class="text">
                    <div class="year">{{report.year}}</div>
                    <div class="name_text">{{report.title}}</div>
                  </div>
                </div>
            </div>
            <div class="pageself" v-if="showList && showList.length > 0">
                  <paginate
                    :pageCount="pageCount"
                    :containerClass="'pagination'"
                    :page-range="3"
                    :clickHandler="pageClick"
                    :first-last-button="false"
                    :prevText="'<'"
                    :nextText="'>'"
                  >
                  </paginate>
              </div>
          </div>
          
        </div>
        
        <!-- <div class="about_yewu_layout" ref="lightFund">
          <div class="yewu_box">
            <div class="web_title">科技点亮公益</div>
            <div class="jijin_img_layout">
              <div class="jijin_list_box">
                <div class="jijin_img">
                  <img src="../../../assets/img/society/keji-2.jpg">
                </div>
                <div class="jijin_text_box">
                  <div class="jijin_title">标题标题标题标题</div>
                  <div class="jijin_word">新升级WPS冬奥版，支持组委会协同编辑电子文档完成工作，助力中国成功实现冬奥会碳排放全部中和目标。</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
              </div>
              <div class="jijin_list_box">
                <div class="jijin_img">
                  <img src="../../../assets/img/society/keji-2.jpg">
                </div>
                <div class="jijin_text_box">
                  <div class="jijin_title">标题标题标题标题</div>
                  <div class="jijin_word">新升级WPS冬奥版，支持组委会协同编辑电子文档完成工作，助力中国成功实现冬奥会碳排放全部中和目标。</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="about_wenhua_layout" ref="buildFuture">
          <div class="web_title">ESG评级与奖项</div>
          <!--
          <div class="society_img_layout">
            <div class="society_img">
              <img src="../../../assets/img/society/weilai-1.jpg">
              <div class="weilai_title">响应碳中和助力国际赛事</div>
              <div class="weilai_word">新升级WPS冬奥版，支持组委会协同编辑电子文档完成工作，助力中国成功实现冬奥会碳排放全部中和目标。</div>
            </div>
            <div class="society_img">
              <img src="../../../assets/img/society/weilai-2.jpg">
              <div class="weilai_title">促进边疆民族地区信息化建设</div>
              <div class="weilai_word">发布WPS Office 维哈柯文版产品，与蒙古文版、藏文版，组成民族地区数字办公三部曲。</div>
            </div>
          </div>-->
          <div class="esg_div_box">
            <div class="esg_list_box">
              <div class="esg_left">
                <div class="left_icon"><i class="iconfont icon-website-esg"></i></div>
                <div class="left_name">MSCI</div>
              </div>
              <div class="esg_fen">AA（2024）</div>
              <div class="esg_fen">BBB（2023）</div>
            </div>
            <div class="esg_list_box">
              <div class="esg_left">
                <div class="left_icon"><i class="iconfont icon-website-esg"></i></div>
                <div class="left_name">S&P ESG Score</div>
              </div>
              <div class="esg_fen">54（2024）</div>
              <div class="esg_fen">43（2023）</div>
            </div>
            <div class="esg_list_box can_touch" @click="openEsg('标普全球《可持续发展年鉴2025（全球版）》.pdf','入选标普全球《可持续发展年鉴2025（全球版）》（The Sustainability Yearbook 2025）')">
              <div class="esg_left" style="width:100%">
                <div class="left_icon"><i class="iconfont icon-website-jiangxiang"></i></div>
                <div class="left_name" >入选标普全球《可持续发展年鉴2025（全球版）》（The Sustainability Yearbook 2025）</div>
              </div>
              <div class="esg_fen"></div>
            </div>
            <div class="esg_list_box can_touch" @click="openEsg('标普全球“行业最佳进步企业”表彰.pdf','荣获标普全球“行业最佳进步企业”表彰')">
              <div class="esg_left">
                <div class="left_icon"><i class="iconfont icon-website-jiangxiang"></i></div>
                <div class="left_name">荣获标普全球“行业最佳进步企业”表彰</div>
              </div>
              <div class="esg_fen"></div>
            </div>
            <div class="esg_list_box can_touch" @click="openEsg('入选标普《可持续发展年鉴（中国版）2024》.pdf','入选中国上市公司协会2023年上市公司ESG优秀实践案例')">
              <div class="esg_left">
                <div class="left_icon"><i class="iconfont icon-website-jiangxiang"></i></div>
                <div class="left_name">入选标普全球《可持续发展年鉴（中国版）2024》</div>
              </div>
              <div class="esg_fen"></div>
            </div>
            <div class="esg_list_box can_touch" @click="openEsg('入选中国上市公司协会2024年上市公司可持续发展优秀实践案例.pdf','入选中国上市公司协会2024年上市公司可持续发展优秀实践案例')">
              <div class="esg_left" style="width:100%">
                <div class="left_icon"><i class="iconfont icon-website-jiangxiang"></i></div>
                <div class="left_name">入选中国上市公司协会2024年上市公司可持续发展优秀实践案例</div>
              </div>
              <div class="esg_fen"></div>
            </div>
            <div class="esg_list_box can_touch" @click="openEsg('金山软件-上市公司ESG优秀实践案例证书.pdf','入选标普《可持续发展年鉴（中国版）2024》')">
              <div class="esg_left">
                <div class="left_icon"><i class="iconfont icon-website-jiangxiang"></i></div>
                <div class="left_name">入选中国上市公司协会2023年上市公司ESG优秀实践案例</div>
              </div>
              <div class="esg_fen"></div>
            </div>
            
          </div>
          
        </div>

      </div>
        
  
      </main>
      <footer-build @gotoBody="gotoBody"></footer-build>
      
      
    </div>
  </template>
  <script>
  
  import UtilEvent from '../utils/UtilEvent.js'

    export default {
      name: 'society',
      components:{UtilEvent},
      props: {
        
      },
      created(){
          
      },
      data () {
        return {
          pageCount:1,
          perPage:4,
          oldScrollTop:0,
          isShowTopTitle:true,
          showSecondTitle:false,
          lockSecondTop:false,
          topDivHeight:0,
          socityData:{total:0,list:[]},
          listShift:[],
          showList:[],
          selectedSecond:'环境、社会及管治报告'
        }
      },
      computed:{
        
      },
      methods:{
        gotoBody(){
          this.$refs.parentDiv.scrollIntoView({
              behavior: "smooth",  // 平滑过渡
          });
        },
        openReport(url){
          window.open(url,'_blank')
        },
        pageClick(num){
          this.showList = this.$PageUtil.getStaticPage(num,this.perPage,this.listShift)
        },
        gotoPoint(point,item){
          let offset = this.$refs[point].offsetTop;
          window.scrollTo({
              top:offset - 60,
              behavior: "smooth",  // 平滑过渡
          });
          setTimeout(()=>{
            this.selectedSecond = item;
          },900)
        },
        scrolling(){
          //获取dom滚动距离
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                      document.body.scrollTop;
          if(scrollTop >= this.topDivHeight){
            this.lockSecondTop = true;
          }else{
            this.lockSecondTop = false;
          }
          let scrollStep = scrollTop - this.oldScrollTop;
          this.oldScrollTop = scrollTop;
          if(!this.lockSecondTop){
            //scrollTop <= this.topDivHeight - 64 此距离是为了避免点击页签时候页面向上时候会把第一个导航漏出来
            if (scrollStep < 0 && (scrollTop <= this.topDivHeight - 64)) {
                this.isShowTopTitle = true;
            } else {
              if(scrollStep > 10){
                this.isShowTopTitle = false;
              }
            }
          }else{
            this.isShowTopTitle = false;
            this.handlerDivsListener();
          }
          
        },
        clickSecondHandler(name){
          if(name == '公益基金会'){
            window.open('https://foundation.kingsoft.com/','_blank')
          }
        },
        handlerDivsListener(){
          
          let arrayName = ["环境、社会及管治报告","ESG评级与奖项"];
          let array = ["report","buildFuture"];
          let prePos = Math.abs(this.$refs[array[0]].getBoundingClientRect().top);
          this.selectedSecond = arrayName[0];
          for(let i = 1;i < array.length;i++ ){
            let temp = this.$refs[array[i]].getBoundingClientRect().top
            let offsetTop = Math.abs(temp);
            if((temp - 58 <= 0) && (offsetTop < prePos)){
              prePos = offsetTop;
              this.selectedSecond = arrayName[i];
            }
          }
          
        },
        openEsg(url,title){
          const newWidown = window.open("/iksnet_api/images/" + url,title);
          newWidown.document.title = title;
        }
        
      },
      watch:{
        
      },
      mounted(){
        //获得头部div高度
        this.topDivHeight = this.$refs.topDiv.offsetHeight;
        //刚加载页面后会有偏移量，便宜后再去监听
        setTimeout(()=>{
          window.addEventListener("scroll", this.scrolling)
        },300)
        new UtilEvent().getSocityInfo(this);
          
      },
      destroyed() {
        window.removeEventListener("scroll", this.scrolling);
      },
    }
    </script>
  
  